export function toYMD(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

export function isSameDay(a, b) {
  return toYMD(a) === toYMD(b);
}

export function formatDiaGrande(date) {
  return new Date(date).toLocaleDateString("pt-BR", {
    weekday: "long",
    day: "numeric",
    month: "long"
  });
}

export function formatDiaSemana(date) {
  return new Date(date).toLocaleDateString("pt-BR", { weekday: "long" });
}

export function formatWeekdayUpper(date) {
  return new Date(date)
    .toLocaleDateString("pt-BR", { weekday: "long" })
    .toUpperCase();
}

export function formatDayMonth(date) {
  return new Date(date)
    .toLocaleDateString("pt-BR", { day: "numeric", month: "long" });
}